import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { useQuery } from '@tanstack/react-query'

export const usePostSeriesQuery = (id: number, enabled?: boolean) => {
  const postSeriesQuery = useQuery({
    queryKey: ['usePostSeriesQuery', id],
    queryFn: async () => {
      const { data } = await MembershipsCreatorV2ApiClient.getPostSeries(
        { id },
        {
          page: 1,
          limit: 9999,
        },
      )

      return data
    },
    enabled,
  })

  return {
    postSeriesQuery,
  }
}
